import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CustomRegistrationService } from '../custom-registration.service';

@Component({
    selector: 'app-user-registration',
    templateUrl: './user-registration.component.html',
    styleUrls: ['./user-registration.component.scss'],
    standalone: false
})
export class UserRegistrationComponent implements OnInit, OnDestroy {
  header: string;
  formData: any;
  creditInvoice: string;
  dummyData: any;
  baseSub: Subscription;
  isLoggedIn: any;

  constructor(
    private readonly accountRegService: CustomRegistrationService,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.header = 'accountInformation';
    this.creditInvoice = 'invoiceTable';

    this.baseSub = this.accountRegService.sectionChange.subscribe(
      (sectionDetails) => {
        this.header = sectionDetails.header;
        if (!!sectionDetails?.form) {
          this.isLoggedIn = sectionDetails.isLoggedIn;
          this.formData = sectionDetails.form;
        }
        if (sectionDetails.header === 'confirmation') {
          this.formData = sectionDetails?.msgData;
        }
        this.cdr.detectChanges();
      }
    );
  }
  ngOnDestroy(): void {
    this.baseSub?.unsubscribe();
  }
}
